import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "form-check mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: `editSeasonModal-${_ctx.season.id}`,
    ref: "modalRef",
    tabindex: "-1",
    "aria-labelledby": "editSeasonModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h5", {
            class: "modal-title",
            id: "editSeasonModalLabel"
          }, "Edit Season"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.editSeason(_ctx.season)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "seasonDescription",
                class: "form-label"
              }, "Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "seasonDescription",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event)),
                required: "",
                placeholder: "Enter season name"
              }, null, 512), [
                [_vModelText, _ctx.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "seasonStartDate",
                class: "form-label"
              }, "Start Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                id: "seasonStartDate",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.startDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "seasonEndDate",
                class: "form-label"
              }, "End Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                id: "seasonEndDate",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.endDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "overrideSeason",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.overrideSeason) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.overrideSeason]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                class: "form-check-label",
                for: "overrideSeason"
              }, " Override Season ", -1))
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex justify-content-end" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary me-2",
                "data-bs-dismiss": "modal"
              }, " Cancel "),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary"
              }, "Save")
            ], -1))
          ], 32)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}